import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

/* /auth/socialpulse-callback — thin bridge to the backend OIDC handler.
   The hub redirects the browser here per its whitelisted redirect_uri; we
   immediately bounce the code + state to /api/auth/socialpulse-callback,
   where the backend owns the PKCE verifier + code exchange + Firebase
   custom-token minting. Backend then 302s to /auth/sso-complete?token=…
   which finishes the sign-in on the client. */
export default function SocialPulseCallback() {
  const [params] = useSearchParams();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    const state = params.get("state");
    const err = params.get("error");
    const qs = new URLSearchParams();
    if (code) qs.set("code", code);
    if (state) qs.set("state", state);
    if (err) qs.set("error", err);
    // Full-page redirect — the backend will 302 us to /auth/sso-complete.
    window.location.replace(`/api/auth/socialpulse-callback?${qs.toString()}`);
  }, [params]);

  return (
    <div className="min-h-[50vh] grid place-items-center text-slate-500 text-sm" data-testid="sso-bridge">
      Signing you in with SocialPulse…
    </div>
  );
}
